import { render, staticRenderFns } from "./OpenPrivacyPolicy.vue?vue&type=template&id=6208eb55&scoped=true&"
import script from "./OpenPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./OpenPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OpenPrivacyPolicy.vue?vue&type=style&index=0&id=6208eb55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208eb55",
  null
  
)

export default component.exports